import Swiper from 'swiper';
import { Thumbs, EffectFade, Pagination } from 'swiper/modules';
Swiper.use([Thumbs, EffectFade, Pagination]);
export default function tabsBlockInit() {
    const tabsBlocks = document.querySelectorAll('[data-js="tabsBlock"]');
    if (tabsBlocks.length < 1)
        return;
    tabsBlocks.forEach((tabsBlock) => {
        const slides = tabsBlock.querySelector('[data-js="tabsBlockSlides"]');
        const tabs = tabsBlock.querySelector('[data-js="tabsBlockList"]');
        const tabsPrev = tabsBlock.querySelector('[data-js="tabsBlockPrev"]');
        const tabsNext = tabsBlock.querySelector('[data-js="tabsBlockNext"]');
        const navigation = tabsPrev && tabsNext ? {
            nextEl: tabsNext,
            prevEl: tabsPrev,
        } : false;
        const tabsFraction = tabsBlock.querySelector('[data-js="tabsBlockFraction"]');
        const pagination = tabsFraction ? {
            el: tabsFraction,
            type: "fraction",
            renderFraction: function (currentClass, totalClass) {
                return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
            },
            formatFractionCurrent: (number) => {
                return ('0' + number).slice(-2);
            },
            formatFractionTotal: (number) => {
                return ('0' + number).slice(-2);
            }
        } : undefined;
        const tabsBlockEq = tabsBlock.querySelector('[data-js="tabsBlockEq"]');
        const tabsBlockDia = tabsBlock.querySelector('[data-js="tabsBlockDia"]');
        if (!slides || !tabs)
            return;
        const tabsList = Array.from(tabs.querySelectorAll('[data-js="tabsBlockTab"]'));
        const originalTransforms = {};
        const vw = window.innerWidth;
        const mobileBP = 767;
        if (vw > mobileBP) {
            arrangeItemsOnCircle(tabs, tabsList);
        }
        const tabsParams = {
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            spaceBetween: 16,
            breakpoints: {
                768: {
                    spaceBetween: 0
                }
            }
        };
        const tabsSliderEx = new Swiper(tabs, tabsParams);
        const slidesParams = {
            slidesPerView: 1,
            spaceBetween: 100,
            allowTouchMove: false,
            simulateTouch: false,
            effect: 'fade',
            speed: 500,
            thumbs: {
                swiper: tabsSliderEx,
            },
            navigation: navigation,
            pagination: pagination,
            on: {
                init: function () {
                    if (tabsBlockEq && tabsBlockDia) {
                        updateEqDiaLabels(tabsList, tabsBlockEq, tabsBlockDia);
                    }
                },
                slideChange: function () {
                    if (vw > mobileBP) {
                        rotateToActiveThumb(tabs, tabsList, originalTransforms);
                    }
                    if (tabsBlockEq && tabsBlockDia) {
                        updateEqDiaLabels(tabsList, tabsBlockEq, tabsBlockDia);
                    }
                },
            },
        };
        const slidesSliderEx = new Swiper(slides, slidesParams);
    });
    function rotateToActiveThumb(container, items, originalTransforms) {
        const thumbActiveClass = 'swiper-slide-thumb-active';
        const currentActiveClass = 'curent-active-class';
        const activeThumb = items.find(item => item.classList.contains(thumbActiveClass));
        const numItems = items.length;
        const angleStep = (2 * Math.PI) / numItems;
        const startAngle = -Math.PI / 3;
        const activeIndex = items.indexOf(activeThumb);
        const currentAngle = startAngle + activeIndex * angleStep;
        const rotationAngle = startAngle - currentAngle;
        items.forEach((item) => {
            const id = item.dataset.id ?? '';
            if (!id || originalTransforms[id] !== undefined)
                return;
            originalTransforms[id] = item.style.transform || '';
        });
        const previousActive = items.find(item => item.classList.contains(currentActiveClass));
        if (previousActive) {
            previousActive.classList.remove(currentActiveClass);
        }
        activeThumb.classList.add(currentActiveClass);
        container.style.transition = 'transform 0.6s linear';
        container.style.transform = `rotate(${rotationAngle}rad)`;
        items.forEach((item) => {
            const id = item.dataset.id ?? '';
            const baseTransform = id ? (originalTransforms[id] ?? '') : '';
            item.style.transition = item.style.transition || 'transform 0s linear';
            item.style.transform = `rotate(${-rotationAngle}rad) ${baseTransform}`.trim();
        });
    }
    function arrangeItemsOnCircle(container, items) {
        const rect = container.getBoundingClientRect();
        const size = rect.width;
        const cx = size / 2;
        const cy = size / 2;
        const radius = size / 2;
        const numItems = items.length;
        const angleStep = (2 * Math.PI) / numItems;
        const startAngle = -Math.PI / 3;
        items.forEach((item, i) => {
            const angle = startAngle + i * angleStep;
            const x = cx + radius * Math.cos(angle);
            const y = cy + radius * Math.sin(angle);
            item.setAttribute('data-id', i.toString());
            item.style.transform = 'translate(-50%, -50%)';
            item.style.left = `${x}px`;
            item.style.top = `${y}px`;
            if (i === 0) {
                item.classList.add('curent-active-tab');
            }
            setTimeout(() => {
                item.style.transition = 'width 0.3s linear, height 0.3s linear, background-color 0.3s linear';
            }, 0);
        });
    }
    function updateEqDiaLabels(tabs, eqElement, diaElement) {
        const activeTab = tabs.find(tab => tab.classList.contains('swiper-slide-thumb-active'));
        const eq = activeTab?.dataset.eq;
        const dia = activeTab?.dataset.dia;
        if (!eq || !dia) {
            return;
        }
        const currentEqText = eqElement.textContent?.trim() || '';
        const targetEq = parseInt(eq);
        if (!isNaN(targetEq) && /^\d+$/.test(currentEqText)) {
            const currentEqNum = parseInt(currentEqText);
            animateNumber(eqElement, currentEqNum, targetEq);
        }
        else {
            eqElement.textContent = eq;
        }
        const currentDiaText = diaElement.textContent?.trim() || '';
        const targetDia = parseInt(dia);
        if (!isNaN(targetDia) && /^\d+$/.test(currentDiaText)) {
            const currentDiaNum = parseInt(currentDiaText);
            animateNumber(diaElement, currentDiaNum, targetDia);
        }
        else {
            diaElement.textContent = dia;
        }
    }
}
function animateNumber(element, from, to) {
    if (from === to) {
        element.textContent = to.toString();
        return;
    }
    const duration = 600;
    const startTime = performance.now();
    function stepAnimation(now) {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const current = Math.round(from + (to - from) * progress);
        element.textContent = current.toString();
        if (progress < 1) {
            requestAnimationFrame(stepAnimation);
        }
    }
    requestAnimationFrame(stepAnimation);
}
